import { useEffect, useState } from "react";
import { Loader } from "lucide-react";
import serverURL from "../../config/serverConfig"

const Notepad = (props) => {

    const [noteData, setNoteData] = useState();
    const [noteInfo, setNoteInfo] = useState();
    const [savedNote, setSavedNote] = useState();
    

    useEffect(() => {
        fetch(serverURL + "getNotes", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                },
            body: JSON.stringify({project_id: props.projectID}),
        })
            .then(response => response.json())
            .then((jsonData) => {
                //projectList = jsonData
                console.log(jsonData[0])
                setNoteData(jsonData[0].detail)
                setSavedNote(jsonData[0].detail)
                setNoteInfo(jsonData[0])
            })
            .catch((error) => {
                console.log(error)
            })
    },[])
    // console.log(noteData)

    const updateNote = () => {
        let updatedContents = noteData
        setSavedNote(noteData)
        fetch(serverURL+"updateNote", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                },
            body: JSON.stringify({
                detail: updatedContents,
                project_id: props.projectID,

            }),
        })
        .then((response) => response.json())
        .then((data) => {
            console.log(data);
            //setUploaded(true)
            //setProjectID(data.project_id)
        })
        .catch((error) => {
            console.log(error)
        });
    }

    return (
        <div id="notepad" >
            <h5 className="blockHeader">Notepad</h5>
                {noteInfo?  
                <div id="noteText">
                    <textarea name="noteData" className="text-xs p-2"
                        placeholder="Write your notes here..."
                        value={noteData? noteData : ""}
                        onChange={e => setNoteData(e.target.value)}
                        rows={10}
                        // cols={40}
                    />
                    <button disabled={noteData==savedNote} onClick={updateNote}>SAVE</button>
                </div>
                :
                    <>
                        <Loader className="spinning"/>
                    </>
                }
        </div>
    )
}

export default Notepad;